module.exports = __webpack_public_path__ + "img/bg.4b19a7d7.png";